import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { commonUrlBuilder, RouteHttpVerb } from "./";
import deepMerge from "deepmerge";
import Url from "url-parse";
import { parseResult } from ".";
import jsonFormData from "json-form-data";
var CONTENT_TYPE_JSON = "application/json;charset=utf-8"; // Fix: Return type of exported function has or is using name 'FormatOptions'
// from external module "/home/mg/vscode-workspace/devowl-wp/node_modules/@types/json-form-data/index" but cannot be named.
// type MultiPartOptions = Parameters<typeof jsonFormData>[1];

/**
 * Build and execute a specific REST query.
 *
 * @see urlBuilder
 * @returns Result of REST API
 * @throws
 */
function commonRequest(_x) {
  return _commonRequest.apply(this, arguments);
}

function _commonRequest() {
  _commonRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var location, options, routeRequest, params, _ref$settings, settings, _ref$multipart, multipart, url, apiUrl, allowBody, body, init, apiUrlBuilt, result, responseJSON, resultAny;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            location = _ref.location, options = _ref.options, routeRequest = _ref.request, params = _ref.params, _ref$settings = _ref.settings, settings = _ref$settings === void 0 ? {} : _ref$settings, _ref$multipart = _ref.multipart, multipart = _ref$multipart === void 0 ? false : _ref$multipart;
            url = commonUrlBuilder({
              location: location,
              params: params,
              nonce: false,
              options: options
            }); // Use global parameter (see https://developer.wordpress.org/rest-api/using-the-rest-api/global-parameters/)

            if (["wp-json/", "rest_route="].filter(function (s) {
              return url.indexOf(s) > -1;
            }).length > 0 && location.method && location.method !== RouteHttpVerb.GET) {
              settings.method = RouteHttpVerb.POST;
            } else {
              settings.method = location.method || RouteHttpVerb.GET;
            } // Request with GET/HEAD method cannot have body


            apiUrl = new Url(url, true);
            allowBody = ["HEAD", "GET"].indexOf(settings.method) === -1;

            if (!allowBody && routeRequest) {
              apiUrl.set("query", deepMerge(apiUrl.query, routeRequest));
            } // Determine body


            if (allowBody) {
              if (multipart) {
                // Let's create a multipart request...
                body = jsonFormData(routeRequest, typeof multipart === "boolean" ? {} : multipart);
              } else {
                // It is a usual JSON request, we do not need to send a multipart request
                body = JSON.stringify(routeRequest);
              }
            } // Do the request


            init = deepMerge.all([settings, {
              headers: _objectSpread(_objectSpread({}, typeof body === "string" ? {
                "Content-Type": CONTENT_TYPE_JSON
              } : {}), typeof options.restNonce !== "undefined" ? {
                "X-WP-Nonce": options.restNonce
              } : {})
            }]);
            init.body = body; // Do not make body merge-able

            apiUrlBuilt = apiUrl.toString();
            _context.next = 12;
            return window.fetch(apiUrlBuilt, init);

          case 12:
            result = _context.sent;

            if (result.ok) {
              _context.next = 27;
              break;
            }

            responseJSON = undefined;
            _context.prev = 15;
            _context.next = 18;
            return parseResult(apiUrlBuilt, result, location.method);

          case 18:
            responseJSON = _context.sent;
            _context.next = 23;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](15);

          case 23:
            // Set this request as failing so the endpoint is probably corrupt (see `corruptRestApi.tsx`)
            settings.method === RouteHttpVerb.GET && (window.detectCorruptRestApiFailed = (window.detectCorruptRestApiFailed || 0) + 1);
            resultAny = result;
            resultAny.responseJSON = responseJSON;
            throw resultAny;

          case 27:
            return _context.abrupt("return", parseResult(apiUrlBuilt, result, location.method));

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[15, 21]]);
  }));
  return _commonRequest.apply(this, arguments);
}

export { commonRequest };